if (!customElements.get("obj-video-vimeo")) {
  /**
   * Custom Web Component for embedding a Vimeo video player with a play overlay.
   *
   * This component wraps an iframe (Vimeo player) and an overlay containing
   * a play button. When the button is clicked, the video starts playing.
   *
   * Example usage:
   * ```html
   * <obj-video-vimeo>
   *   <div class="obj-video-play__vimeo">
   *     {% render 'twas-icon-play', as_button: true %}
   *   </div>
   *   <iframe
   *     class="iframe-vimeo"
   *     src="https://player.vimeo.com/video/{{ video_id }}?color=ffffff&controls=0"
   *     frameborder="0"
   *     allow="autoplay; fullscreen; picture-in-picture"
   *     allowfullscreen
   *   ></iframe>
   * </obj-video-vimeo>
   * ```
   *
   * @customElement
   * @extends HTMLElement
   */
  class ObjVideoVimeo extends HTMLElement {
    constructor() {
      super();

      this.play = this.play.bind(this);
      this.iframe = this.querySelector("iframe");
      this.playOverlay = this.querySelector(".obj-video-play__vimeo");
    }

    connectedCallback() {
      this.playOverlay.addEventListener("click", this.play);
    }

    disconnectedCallback() {
      this.playOverlay.removeEventListener("click", this.play);
    }

    play() {
      if (!this.iframe)
        return console.warn("[obj-video-vimeo] - No iframe found");
      const newSrc = this._createNewSrc();
      this.iframe.src = newSrc;

      this.hideOverlay();
    }

    hideOverlay() {
      if (!this.playOverlay)
        return console.warn("[obj-video-vimeo] - No play overlay found");
      this.playOverlay.classList.add("hidden");
    }

    _createNewSrc() {
      const src = this.iframe.src;
      const params = new URLSearchParams(this.iframe.src);
      const newSrc = new URL(src);

      params.set("autoplay", 1);
      params.set("controls", 1);
      params.set("colors", "000000, f2f2f2, f2f2f2, 000000");
      params.set("play_button_position", "bottom");
      newSrc.search = params.toString();
      return newSrc.href;
    }
  }

  customElements.define("obj-video-vimeo", ObjVideoVimeo);
}
